module.exports = __webpack_public_path__ + "media/images/flags/64/Hungary-d5de2c07fa63b592d5683cd8d7c3d621.png";